import Vue from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';
import vuetify from './plugins/vuetify';
Vue.config.productionTip = false;
new Vue({
    store: store,
    vuetify: vuetify,
    router: router,
    render: function (h) { return h(App); }
}).$mount('#app');
